$(function(){
    $('.js-modal-open').on('click',function(){
        $('.js-modal').fadeIn();
        return false;
    });
    $('.js-modal-close').on('click',function(){
        $('.js-modal').fadeOut();
        return false;
    });
  
/*スクロールで表示*/
$(window).on('load scroll', function(){
  if ($(window).scrollTop() > 1000) {
   $('.follow-btn').fadeIn(400);
   } else {
    $('.follow-btn').fadeOut(400);
  }
  });
  
});